
<template>
  <zj-layout-container
    v-loading="isEventInfoLoading || loading"
    :element-loading-text="loadingText"
  >
    <zj-layout-header>
      <EventTimeLine :timeIndex="status"></EventTimeLine>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <EventInfo
          :EventConfirm="EventConfirm"
          :EventInfoEdit="EventInfoEdit"
          :EventSourceEdit="EventSourceEdit"
          :EventAffectEdit="EventAffectEdit"
          :EventConfirmEdit="EventConfirmEdit"
          :editable="editable"
          :EventReport="EventReport"
          :IsOnlyView="true"
          :activeNames="activeNames"
          :IsNoLoading="true"
          @showLoading="onEventInfoShowLoading"
          @hideLoading="onEventInfoHideLoading"
        >
          <template name="default">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="16rem"
              class="finisheventform"
            >
              <el-collapse v-model="activeNames" style="margin-top: 2px">
                <el-collapse-item name="EmergencyCommand">
                  <template slot="title">
                    <i class="header-icon el-icon-arrow-down"></i>
                    <span class="spantitle">应急指挥：</span>
                  </template>
                  <el-form-item
                    label="接报核实耗时"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="Re_veTakeTime"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="态势分析耗时"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="SituationAnalysisTime"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="应急处置耗时"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="EmergencyResponseTime"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="任务派发量"
                    style="display: inline-block"
                  >
                    <el-input v-model="TaskVolume" disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="异常任务数量"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="UnusualTaskVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="任务完成数量"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="CompleteTaskVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="调动应急人员"
                    style="display: inline-block"
                  >
                    <el-input v-model="RescueVolume" disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="调动应急物资"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="MeterialVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="调动应急车辆"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="TransportVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="应急处置成本估算"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      type="textarea"
                      rows="3"
                      v-model="ruleForm.costCalculation"
                    ></el-input>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="EventSummary" class="EventSummary">
                  <template slot="title">
                    <i class="header-icon el-icon-arrow-down"></i>
                    <span class="spantitle">事件总结</span>
                  </template>
                  <el-form-item label="事件总结">
                    <el-input
                      type="textarea"
                      rows="5"
                      v-model="ruleForm.eventSummary"
                      show-word-limit
                      maxlength="500"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="善后负责人" prop="aftermathChargeId">
                    <el-select v-model="ruleForm.aftermathChargeId">
                      <el-option-group
                        v-for="group in UsersOptions"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="善后参与人"
                    prop="aftermathParticipant"
                    class="AfterparticipaterUsers"
                  >
                    <el-select
                      multiple
                      multiple-limit="10"
                      v-model="ruleForm.aftermathParticipant"
                    >
                      <el-option-group
                        v-for="group in UsersOptions"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="善后处理意见">
                    <el-input
                      type="textarea"
                      rows="5"
                      v-model="ruleForm.aftermathOpinion"
                    ></el-input>
                  </el-form-item>
                </el-collapse-item>
              </el-collapse>
            </el-form>
          </template>
        </EventInfo>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="text-align: center">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="ConfirmSummary()">确认</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import EventTimeLine from "./EventTimeLine.vue";
import EventInfo from "./EventInfo.vue";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { aggregationResouceType, update, detail } from "@/api/src/emergency_event";
import { list } from "@/api/src/emergency_person";
import { list as commandTaskList } from "@/api/src/emergency_command_task";

import dayjs from 'dayjs'

export default {
  name: "ZjFinishEvent",
  controller: "UI",
  action: "FinishEvent",
  components: {
    EventTimeLine,
    EventInfo,
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中",
      isEventInfoLoading: false,
      UsersOptions: [],
      ChildUser: [],
      status: parseInt(this.$route.query.Status),
      EventInfoEdit: true,
      EventSourceEdit: true,
      EventAffectEdit: true,
      EventConfirmEdit: true,
      editable: false,
      EventReport: this.$route.query.IsReport == null,
      activeNames: ["EmergencyCommand", "EventSummary"],
      Re_veTakeTime: "",
      SituationAnalysisTime: "",
      EmergencyResponseTime: "",
      TaskVolume: "",
      UnusualTaskVolume: "",
      CompleteTaskVolume: "",
      RescueVolume: "",
      MeterialVolume: "",
      TransportVolume: "",
      ruleForm: {
        costCalculation: "",
        eventSummary: '',
        aftermathChargeId: "",
        aftermathParticipant: "",
        aftermathOpinion: "",
        id: "", //应急事件Id
      },
    };
  },
  created: function () {
    let { id } = this.$route.query
    this.ruleForm.id = id
    this.showLoading("加载中...");
    utils
      .waitAll([
        getDictionary('organization_type'),
        list({
          page:1,
          size:10000,
        }),
        detail( id ),
        commandTaskList({ eventId: id,current:1,size:10000 }),
        aggregationResouceType({ eventId: id })
      ])
      .then((r) => {
        this.GetUserData(r[0].data.records, r[1].data.records);

        const stat = r[2].data;
        //console.log(r);
        this.Re_veTakeTime = this.getDiff(stat.checkTime, stat.happenTime)
        this.SituationAnalysisTime = this.getDiff(stat.startTime, stat.checkTime)
        this.EmergencyResponseTime =  this.getDiff(new Date(), stat.reportTime)

        const TaskList = r[3].data.records;
        this.TaskVolume = TaskList.length;
        let Unusual = TaskList.filter(item=> item.status == 3)
        this.UnusualTaskVolume = Unusual ? Unusual.length : 0;
        let complete = TaskList.filter(item=> item.status == 2)
        this.CompleteTaskVolume = complete ? complete.length : 0;

        const ResouceInfo = r[4].data;
        ResouceInfo.map(item =>{
          if(item.resourceType == 1){
            this.RescueVolume = item.num
          }else if(item.resourceType == 2){
            this.MeterialVolume = item.num
          }else if(item.resourceType == 6){
            this.TransportVolume = item.num
          }
        })

        this.hideLoading();
      })
      .catch((e) => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    getDiff(new_date, old_date){
      var new_date = new Date(new_date); 
      var old_date = new Date(old_date);
      var difftime = (new_date - old_date)/1000; //计算时间差,并把毫秒转换成秒
    
      var days = parseInt(difftime/86400); // 天  24*60*60*1000 
      var hours = parseInt(difftime/3600)-24*days;    // 小时 60*60 总小时数-过去的小时数=现在的小时数 
      var minutes = parseInt(difftime%3600/60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
      var seconds = parseInt(difftime%60);  // 以60秒为一整份 取余 剩下秒数

      return days + '天' + hours + "小时" + minutes + '分' + seconds + '秒'
    },
    showLoading(text) {
      this.loading = true;
      this.loadingText = text || "";
    },
    hideLoading() {
      this.loading = false;
    },
    onEventInfoShowLoading(e) {
      this.isEventInfoLoading = true;
      this.loadingText = e.text;
    },
    onEventInfoHideLoading() {
      this.isEventInfoLoading = false;
    },
    GetUserData(Fatoption, Chiloption) {
      this.ChildUser = Chiloption;
      var userOpt = [];
      for (var i = 0; i < Fatoption.length; i++) {
        var item = Fatoption[i];
        var users = [];
        for (var j = 0; j < Chiloption.length; j++) {
          var user = Chiloption[j];
          if (user.belongDeptType == item.code) {
            users.push({ value: user.id, label: user.name });
          }
        }
        userOpt.push({
          label: item.value,
          options: users,
        });
      }
      this.UsersOptions = userOpt;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //确认
    ConfirmSummary() {
      // 保存总结信息
      let aftermathParticipantArr = this.ruleForm.aftermathParticipant;
      let ruleForm = utils.extend({}, this.ruleForm, {
        aftermathParticipant: JSON.stringify(aftermathParticipantArr || []),
        status: this.status,
        closeTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      });

      this.showLoading("保存中...");
      update(ruleForm)
        .then((r) => {
          if (r && r.data) {
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            //跳转到待归档列表
            this.$router.push({
              path: "/plugin/emergency/ui/EventList",
              query: { Status: 5 },
            });
          }
          this.hideLoading();
        })
        .catch((e) => {
          console.error(e);
          this.hideLoading();
        });
    },
  },
};
</script>
<style lang="scss">
.finisheventform .el-input {
  width: 20rem;
}
.finisheventform .el-textarea {
  width: 96rem;
}
.finisheventform .el-date-editor {
  width: 96rem;
}
.finisheventform .EventSummary {
  .el-select {
    width: 20rem;
  }
  .AfterparticipaterUsers {
    .el-select {
      width: 96rem;
      .el-input {
        width: 96rem;
      }
    }
  }
}

.finisheventform .el-input__count {
  background: #074e85b3 !important;
}
</style>